module.exports = {
  endpoint: '__events_domain__/v2/perf-metric',
  deviceInfoMetrics: ['ram-size', 'cpu-cores'],
  connectionInfoMetrics: ['network-type', 'network-speed', 'user-agent', 'save-data', 'rtt'],
  clientInfo: ['name', 'version'],
  tags: ['platform', 'site', 'application', 'device', 'webview', 'scope'],
  browserInfoMetrics: ['d2id', 'url', 'dark-mode', 'session-id'],
};
